import styled from 'styled-components'
import { type NutritionalWarning } from '@/features/shop/services/Product/types'
import { Body } from '@shipt/design-system-typography'
import { Box } from '@shipt/design-system-layouts'

type Props = {
  className?: string
  warnings: NutritionalWarning[]
}

export const NutritionalWarnings = ({ className, warnings = [] }: Props) => (
  <div className={className}>
    {warnings.map((prod) => (
      <WarningWrapper key={prod.name}>
        <Body variant="secondary" strong size="sm">
          {prod.name}
        </Body>
        <Box marginTop="xs" marginBottom="xs">
          <Body variant="secondary" strong size="sm">
            WARNING
          </Body>
        </Box>
        <Body size="sm" variant="secondary">
          {prod.warnings}
        </Body>
      </WarningWrapper>
    ))}
  </div>
)

const WarningWrapper = styled.div`
  margin-bottom: 24px;
`
